import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import isUndefined from 'lodash/isUndefined';

var ErrorDataMessageConfig = /*#__PURE__*/function () {
  function ErrorDataMessageConfig() {
    _classCallCheck(this, ErrorDataMessageConfig);

    /**
     * @type {?Object}
     */
    this.config = null;
  }

  _createClass(ErrorDataMessageConfig, [{
    key: "getConfig",
    value:
    /**
     * @returns {?Object}
     */
    function getConfig() {
      return this.config;
    }
    /**
     * @param {string|number} key
     *
     * @returns {?(string|function)}
     */

  }, {
    key: "getValueByKey",
    value: function getValueByKey(key) {
      return this.config === null || isUndefined(this.config[key]) ? null : this.config[key];
    }
    /**
     * @param {?Object} value
     *
     * @returns {ErrorDataMessageConfig}
     */

  }, {
    key: "setConfig",
    value: function setConfig(value) {
      this.config = value;
      return this;
    }
  }], [{
    key: "merge",
    value: function merge(errorDataConfig, sourceErrorDataConfig) {
      var config = _objectSpread(_objectSpread({}, errorDataConfig.getConfig() || {}), sourceErrorDataConfig.getConfig() || {});

      return new ErrorDataMessageConfig().setConfig(Object.keys(config) ? config : null);
    }
  }]);

  return ErrorDataMessageConfig;
}();

export { ErrorDataMessageConfig as default };